/** Resuelve rutas de /public respetando el base de Vite (dev: '/', build: '/navimarket/'). */
export function asset(path: string): string {
  return import.meta.env.BASE_URL + path.replace(/^\//, '');
}
